/*
 * Canonicals are generated automatically as:
 * https://workdayz.in + current page path
 *
 * Add an entry here only when a page needs a different canonical URL.
 */
export const siteUrl = "https://workdayz.in";

const pageCanonicals = {
  "/uniform-manufacturer/industrial":
    "https://workdayz.in/uniform-manufacturer/industrial",
};

export default pageCanonicals;
